import Bulb from './core/bulb';


////////////////////////////////////////
window.onload = function () {
    new Bulb();
};



// WEBPACK FOOTER //
// ./scripts/main.js